import React, { useEffect, useRef, useState } from 'react'
import { AutoComplete, Button, Flex, Form, Input, Modal, Select } from 'antd'
import './CreateOwnedCar.scss'
import { addCarInterested, ICustomerDetail_V2, ICustomerDetail_V4 } from '../../../api/customer/customerApi'
import { useForm } from 'antd/es/form/Form'
import useToast from '../../../hook/useToast'
import { FormInstance, FormProps } from 'antd/lib'
import { getListCarCompany, IRelative, ISelectOption } from '../../../api/selectOptions/selectOptionsApi'
import useDebounce from '../../../hook/useDebounce'
import { getCLCarLines, getCLTypeVehicle, getInforSearchCar, getSearchCar } from '../../../api/selectOption/selectOptionsApi'
import { fommatSelectOption } from '../../../until'

const { Search } = Input

interface Props {
  show: boolean
  infoCustomer?: ICustomerDetail_V4;

  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  modalClose?: () => void
}

const CreateFavoriteCarModal: React.FC<Props> = ({
  show, infoCustomer,
  modalClose, onSubmitFormModal
}) => {
  const [form] = useForm();
  const pushToast = useToast()
  const inputRef = useRef<FormInstance>(null);

  const [categoryCar, setCategoryCar] = useState<IRelative[]>([])
  const [carLines, setCarLines] = useState<IRelative[]>([])//d xe
  const [typeVehicle, setTypeVehicle] = useState<IRelative[]>([])// loại xe

  const [idCar, setIdCar] = useState<number>()

  const [optionsSearch, setOptionsSearch] = useState<ISelectOption[]>([]);

  //thương hiệu
  const gCLCarCompany = async () => {
    const result = await getListCarCompany()
    if (result?.status) {
      setCategoryCar(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  // Tìm xe
  const gSearchCar = useDebounce(async (isSearch?: string, id?: number) => {
    const result = await getSearchCar(isSearch, id)

    if (result?.status) {
      setOptionsSearch(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
  }, 500)
  // chọn option khi search
  const handleSelectSearch = async (id: number) => {
    setIdCar(id)
    const result = await getInforSearchCar(id)
    if (result?.status) {
      const { id, title } = result.data.categoryCar
      setCategoryCar([{ id, title }])
      changeCategoryCar(result.data.categoryCar.id)
      changeCarLines(result.data.typeVehicle.id)
      form.setFieldsValue({
        "brand": id,
        "carLines": result.data.carLine.id,
        "typeCar": result.data.typeVehicle.id
      })
    }

  }
  //dòng xe
  const changeCategoryCar = useDebounce(async (id: number, isSearch?: boolean) => {
    if (isSearch) {
      form.setFieldValue('typecar', undefined)
      form.setFieldValue('categorycar', undefined)
    }
    const result = await getCLCarLines(id)
    if (result?.status) {
      setCarLines(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 200)

  //loại xe
  const changeCarLines = useDebounce(async (id: number, isSearch?: boolean) => {
    if (isSearch) {
      form.setFieldValue('categorycar', undefined)
    }
    const result = await getCLTypeVehicle(id)
    if (result?.status) {
      setTypeVehicle(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 200)

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFormFinish: FormProps["onFinish"] = async (values) => {

    const result = await addCarInterested(infoCustomer?.id, idCar, values.brand, values.carLines, values.typeCar, values.yearOfManufacture)
    if (result?.status) {
      onSubmitFormModal?.(true)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  }

  useEffect(() => {
    if (show) {
      gCLCarCompany()
      gSearchCar()
    } else {
      form.resetFields()
    }
  }, [show])
  return (
    <Modal
      open={show}
      title='Tạo xe quan tâm'
      className='rs-modal w-572 footer-content-end create-owned-car-modal'
      footer={
        <Button
          type='primary'
          className='rs-button rs-button--sm'
          onClick={submitForm}
        >Tạo xe</Button>
      }
      onCancel={modalClose}
    >
      <Form
        form={form}
        ref={inputRef}
        className='rs-form create-owned-car-form'
        onFinish={onFormFinish}
      >
        <Flex>
          <Form.Item
            layout='vertical'
            label='Tên xe'
            name='brand'
          >
            <Select
              placeholder='Thương hiệu'
              popupMatchSelectWidth={false}
              options={fommatSelectOption(categoryCar)}
              onChange={(e) => changeCategoryCar(e, true)}
              className='rs-select br-right-none'

            />

          </Form.Item>
          <Form.Item layout="vertical" label=" " name="searchCar" className='w-100'>
            <AutoComplete

              options={optionsSearch}
              placeholder="Tìm kiếm theo tên xe"
              className="rs-search rs-select ant-select-single br-left-none"
              fieldNames={{ value: 'label', label: 'label' }}
              onSearch={gSearchCar}
              onSelect={(value, option) => handleSelectSearch(option.value)}
            >
              <Search />
            </AutoComplete>
          </Form.Item>
        </Flex>


        <Form.Item
          layout='vertical'
          label='Dòng xe'
          name='carLines'
        >
          <Select
            placeholder='Dòng xe'
            className='rs-select'
            onChange={(e) => changeCarLines(e, true)}
            options={fommatSelectOption(carLines)}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Loại xe'
          name='typeCar'
        >
          <Select
            placeholder='Loại xe'
            className='rs-select'

            options={fommatSelectOption(typeVehicle)}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Năm sản xuất'
          name='yearOfManufacture'
        >
          <Input
            placeholder='Năm sản xuất'
            className='rs-input rs-input--32'
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CreateFavoriteCarModal
